import React from "react";

const UploadFile = ({
  className,
  label,
  onChange,
  onInput,
  required,
  inputName,
  buttonId,
  onClick,
  formData,
  inputClassName,
  disabled,
}) => {
  return (
    <div className={className}>
      <label htmlFor={"input-file-" + inputName} className="form-label fw-bold">
        {label}&nbsp;
        <span className="text-danger">*</span>
      </label>
      <div className="col-12 col-md-6">
        <div className="d-flex align-items-center position-relative form-upload">
          <input
            className={"form-control files-upload getLabel " + inputClassName}
            type="file"
            name={inputName}
            onChange={onChange}
            onInput={onInput}
            id={"input-file-" + inputName}
            required={required}
            accept="image/png, image/jpeg, image/jpg, .pdf"
            disabled={disabled}
          />
          <span
            className="alert alert-secondary m-0 files-upload-supp"
            data-bs-toggle="modal"
            data-bs-target={"#Modal" + inputName}
          >
            <i
              className="btn-icon far fa-trash-alt fa-lg"
              title="Supprimer les pièces jointes"
            ></i>
          </span>
          <div
            className="modal fade"
            id={"Modal" + inputName}
            tabIndex="-1"
            aria-labelledby="ModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title">Confirmer la suppression</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Êtes-vous sur de vouloir supprimer les pièces jointes ?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-warning btn-md"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button
                    type="button"
                    className="btn btn-warning btn-md"
                    name={inputName}
                    id={buttonId}
                    onClick={onClick}
                    data-bs-dismiss="modal"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="invalid-tooltip file-size d-none"
            id="file-size-alert_MandataireAnnexe"
          >
            Le fichier sélectionné est trop volumineux
          </div>
          <div className="invalid-tooltip">
            Veuillez remplir ce champs obligatoire
          </div>
        </div>
        {formData.files &&
          Array.isArray(formData.files[inputName]) &&
          formData.files[inputName].length > 0 && (
            <div className="alert alert-success mt-2 d-block" role="alert">
              {formData.files[inputName].map((item, index) => (
                <p key={index} className="m-0">
                  &#10004;&nbsp;{item}
                </p>
              ))}
            </div>
          )}
      </div>
    </div>
  );
};

export default UploadFile;
